var React = require('react');

function VideoControlsExpandInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21 3V9.75L14.25 3H21ZM3 21V14.25L9.75 21H3ZM21 14.25V21H14.25L21 14.25ZM3 3V9.75L9.75 3H3Z","fill":"currentColor"}));
}

VideoControlsExpandInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VideoControlsExpandInline;

VideoControlsExpandInline.default = VideoControlsExpandInline;
